module.exports = __webpack_public_path__ + "img/bones_quiz_button.f1dc48dd.jpg";